import { render, staticRenderFns } from "./CheckCertificate.vue?vue&type=template&id=6968e900"
import script from "./CheckCertificate.vue?vue&type=script&lang=js"
export * from "./CheckCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports